/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Lars Munkholm
 Modified by:
 Client name: Danske Regioner
 Date of creation: 30.3.2016
 */


(function ($, dis) {
	"use strict";


	dis.ArticlesList = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {
				container: "articles-list",
				filtersBEMsuffix: "filters",
				filtersSelectedBEMsuffix: "selected",
				contentBEMsuffix: "articles",
				contentResultsBEMsuffix: "results",
				articlesListBEMsuffix: "list",
				currentPage: 1
			},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			urlQuery,
			filterSelectors = [],
			selfScope = this;

		// Function for filtering and getting articles
		selfScope.filterAndGetArticles = function (updateUrl) {
			var filterData = {
					page: configuration.currentPage
				},
				url = dom.form.data("url");

			// Fill object (filterData) with data from filters - duh
			dom.filters.each(function () {
				var current = $(this),
					name = current.attr("name"),
					value = current.val();

				// Add to data object if an option in this filter is selected
				if (value) {
					filterData[name] = value;
				}
			});

			// Convert object with filter data to a traditional serialized URL query
			filterData = $.param(filterData, true);

			// Send data from filters to web service
			dom.content.addClass("loading");
			$.ajax(url, {
				method: "GET",
				cache: false,
				data: filterData,
				success: function (response) {
					// Regenerate pagination
					selfScope.generatePagination(response.totalItems, response.links);

					// Put new list of articles in DOM
					dom.articlesList.html(response.html);

					// Scroll to top of list of articles, if it's outside viewport
					if (dom.content[0].getBoundingClientRect().top < 0) {
						$("html, body").animate({
							scrollTop: dom.content.offset().top
						}, 500);
					}

					if (updateUrl !== false) {
						// Change query in URL (the replace-function removes cache busting, which screws up the browser history)
						var newUrl = response.links.self.href.replace(/(&_=[0-9]+)/, "");
						window.history.pushState({path: newUrl}, "", newUrl);
						urlQuery = window.location.search;
					}

					dom.content.removeClass("loading");
				}
			});


		};


		// Function for generating pagination
		selfScope.generatePagination = function (totalItems, links) {
			// Print total results
			dom.results.text(totalItems);

			// Print links
			var pageList = $("<ul />"),
				i = 0,
				pagesTotal = links.pages.length;
			if (pagesTotal && links.previous) {
				pageList.append('<li class="prev" href="' + links.previous.href + '"><a href="' + links.previous.href + '">' + "<svg href=" + links.previous.href + " xmlns='http://www.w3.org/2000/svg' width='11' height='16' viewBox='0 0 11 16' fill='none'><path d='M0.792284 8.07853L8.48007 15.5L10.207 13.6794L4.41334 8.07853L10.207 2.32057L8.48007 0.5L0.792284 8.07853Z' fill='black' /></svg>" + '</a></li> ');
			}

			for (; i < pagesTotal; i += 1) {

				if (i > configuration.currentPage - 4 && i < configuration.currentPage + 2) {

					pageList.append('<li' + (configuration.currentPage === i + 1 ? ' class="active pagelistitem page'+links.pages[i].name+'"' : '') + '><a href="' + links.pages[i].href + '">' + links.pages[i].name + '</a></li> ');
				}
				else if (i === configuration.currentPage - 4) {
					pageList.append('<li' + (configuration.currentPage === i + 1 ? ' class="active pagelistitem page'+links.pages[i].name+'"' : '') + '><a href="' + links.pages[i].href + '">...</a></li>');
				}
				else if (i === configuration.currentPage + 2) {
					pageList.append('<li' + (configuration.currentPage === i + 1 ? ' class="active pagelistitem page'+links.pages[i].name+'"' : '') + '><a href="' + links.pages[i].href + '">...</a></li> ');
				}
			}

			if (pagesTotal && links.next) {
				pageList.append('<li class="next" href="' + links.next.href + '"><a href="' + links.next.href + '">' + "<svg href=" + links.next.href + " xmlns='http://www.w3.org/2000/svg' width='11' height='16' viewBox='0 0 11 16' fill='none'><path d='M0.792284 8.07853L8.48007 15.5L10.207 13.6794L4.41334 8.07853L10.207 2.32057L8.48007 0.5L0.792284 8.07853Z' fill='black' /></svg>" + '</a></li> ');
			}
			dom.pagination.html(pageList);
		};


		// Function for telling all filter selectors to rebuild
		selfScope.rebuildSelectors = function () {
			for (var i = 0, l = filterSelectors.length; i < l; i += 1) {
				filterSelectors[i].eventHandlers.rebuild();
			}
		};


		function init() {
			dom.container = $(configuration.container);

			if (dom.container.length) {
				// Get current page number
				var urlQueryPage = window.location.search.match(/page=\d+/i);
				if (urlQueryPage) {
					configuration.currentPage = parseInt(urlQueryPage[0].substr(5));
				}

				// Find stuff in the DOM
				dom.form = dom.container.find("form");
				dom.filters = dom.container.find(configuration.container + "__" + configuration.filtersBEMsuffix + " select");
				dom.results = dom.container.find(configuration.container + "__" + configuration.contentBEMsuffix + "__" + configuration.contentResultsBEMsuffix);
				dom.pagination = dom.container.find(".pagination");
				dom.content = dom.container.find(configuration.container + "__" + configuration.contentBEMsuffix);
				dom.articlesList = dom.container.find(configuration.container + "__" + configuration.contentBEMsuffix + "__" + configuration.articlesListBEMsuffix);

				// Make filters stylized and listen for changes
				dom.filters.each(function () {
					filterSelectors.push(new dis.Selector({
						selector: this,
						selectedWrapper: configuration.container + "__" + configuration.filtersBEMsuffix + "__" + configuration.filtersSelectedBEMsuffix
					}));
				});

				dom.form.submit(function (e) {
					e.preventDefault();

					configuration.currentPage = 1;
					// Filter and get articles.
					selfScope.filterAndGetArticles();
				});

				// Listen for back/forward in browser history
				// window.addEventListener("popstate", function () {
				// 	// Continue if query in URL has changed
				// 	if (window.location.search !== urlQuery) {
				// 		// Get query from URL and split it into an array
				// 		var urlQueries = window.location.search.replace("?", "").split("&"),
				// 			i = 0,
				// 			l = urlQueries.length,
				// 			filters = {},
				// 			pageNumber;
				//
				// 		// Loop through array of queries and add them to an object of filters
				// 		for (; i < l; i += 1) {
				// 			var thisQuery = urlQueries[i].split("=");
				//
				// 			if (!filters[thisQuery[0]]) {
				// 				filters[thisQuery[0]] = [];
				// 			}
				//
				// 			filters[thisQuery[0]].push(thisQuery[1]);
				// 		}
				//
				// 		// Change page number
				// 		pageNumber = (filters.page && filters.page[0] ? filters.page[0] : 1);
				// 		configuration.currentPage = parseInt(pageNumber);
				// 		delete filters.page;
				//
				// 		// Reset all filter options to unselected
				// 		dom.filters.find("option").prop("selected", false);
				//
				// 		// Loop through object of filters and set selected options
				// 		for (var filter in filters) {
				// 			if (filter && filters.hasOwnProperty(filter)) {
				// 				var filterSelect = dom.filters.filter("[name=" + filter + "]");
				// 				for (var ii = 0, ll = filters[filter].length; ii < ll; ii += 1) {
				// 					filterSelect.find("option[value=" + filters[filter][ii] + "]").prop("selected", true);
				// 				}
				// 			}
				// 		}
				//
				// 		// Save URL query
				// 		urlQuery = window.location.search;
				//
				// 		// Rebuild styled selectboxes
				// 		selfScope.rebuildSelectors();
				//
				// 		// Filter and get articles
				// 		selfScope.filterAndGetArticles(false);
				// 	}
				// });

				// Listen for clicks on links in pagination
				$(document).on("click", configuration.container + " .pagination a", function (event) {
					event.preventDefault();
					console.log($(event.target).attr("href"));

					// Get page number of clicked link
					var clickedUrl = $(event.target).attr("href"),
						clickedUrlRegex = clickedUrl.match(/page=\d+/i),
						pageNumber = (clickedUrlRegex ? parseInt(clickedUrlRegex[0].substr(5)) : 1);
					// Change page number
					configuration.currentPage = pageNumber;

					// Filter and get articles
					selfScope.filterAndGetArticles();
				});
			}
		}

		selfScope.onReady(init);
	};

	dis.ArticlesList.prototype = new dis.BaseModule();
	dis.ArticlesList.constructor = dis.ArticlesList;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.

	// if($(".subpage__menu") === null) {
	// 	$(".subpage__content").removeClass("show-left-box");
	// 	console.log("tetet");
	// }

	if (!document.getElementById("subpage__menu-wrapper")) {
		$(".subpage__content").removeClass("show-left-box");
		console.log("tetet");
		} else {
			console.log("errro");

		}

}(jQuery, dis));
